module.exports = __webpack_public_path__ + "img/u4377.ac7d9168.svg";